// apps/frontend/src/lib/tutorialState.ts
//
// Persistance du tutorial Glowp : 3 etats possibles cote user.
//  - dismissed  : "Fermer" → ne plus jamais montrer
//  - snoozed    : "Plus tard" → re-show apres SNOOZE_MS
//  - completed  : a parcouru jusqu'au bout → comme dismissed (ne plus show)

const KEY_DISMISSED = 'glowp_tutorial_dismissed';
const KEY_SNOOZED_UNTIL = 'glowp_tutorial_snoozed_until';
const KEY_COMPLETED = 'glowp_tutorial_completed_at';

const SNOOZE_MS = 3 * 24 * 60 * 60 * 1000; // 3 jours

export const isTutorialDismissed = (): boolean => {
  if (typeof window === 'undefined') return true;
  try {
    return (
      localStorage.getItem(KEY_DISMISSED) === '1' ||
      !!localStorage.getItem(KEY_COMPLETED)
    );
  } catch {
    return true;
  }
};

export const isTutorialSnoozed = (): boolean => {
  if (typeof window === 'undefined') return true;
  try {
    const until = Number(localStorage.getItem(KEY_SNOOZED_UNTIL) || 0);
    return until > Date.now();
  } catch {
    return true;
  }
};

export const markTutorialDismissed = (): void => {
  try {
    localStorage.setItem(KEY_DISMISSED, '1');
  } catch {
    /* ignore */
  }
};

export const markTutorialSnoozed = (): void => {
  try {
    localStorage.setItem(KEY_SNOOZED_UNTIL, String(Date.now() + SNOOZE_MS));
  } catch {
    /* ignore */
  }
};

export const markTutorialCompleted = (): void => {
  try {
    localStorage.setItem(KEY_COMPLETED, new Date().toISOString());
  } catch {
    /* ignore */
  }
};

export const resetTutorialState = (): void => {
  try {
    localStorage.removeItem(KEY_DISMISSED);
    localStorage.removeItem(KEY_SNOOZED_UNTIL);
    localStorage.removeItem(KEY_COMPLETED);
  } catch {
    /* ignore */
  }
};

export const shouldShowTutorial = (): boolean => {
  if (isTutorialDismissed()) return false;
  if (isTutorialSnoozed()) return false;
  return true;
};
